import { Box, Typography } from '@monorepo/nova-ui';
import { styled } from '@mui/material/styles';

export const StyledSwiperWrapper = styled(Box)(() => ({
  width: '100%',
  minWidth: 0,
  overflow: 'hidden',
  flex: 1,
  minHeight: 0,
  '& .swiper': {
    width: '100%',
    minWidth: 0,
    height: '100%',
  },
  '& .swiper-wrapper': {
    boxSizing: 'border-box',
  },
  '& .swiper-slide': {
    width: '100%',
    height: '100%',
    boxSizing: 'border-box',
    cursor: 'default',
    display: 'flex',
    flexDirection: 'column',
  },
}));

export const StyledDescription = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontFamily: theme.typography.fontFamily,
  fontSize: theme.typography.pxToRem(14),
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '150%',
  letterSpacing: '0.06px',
  marginBottom: theme.spacing(6),
  height: '25vh',
  overflowY: 'auto',
  [theme.breakpoints.down('md')]: {
    fontSize: theme.typography.pxToRem(12),
    marginBottom: theme.spacing(4),
    height: '15vmax',
  },
  '& *': {
    fontFamily:
      '"General Sans", "Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  },
}));
